// video utube

        $('.ytvideo[data-video]').one('click', function() {

          var $this = $(this);
          var width = $this.attr("width");
          var height = $this.attr("height");
          
        $this.html('<iframe src="https://www.youtube.com/embed/' + $this.data("video") + '?autoplay=1"></iframe>');
        });

        // additional JS

        $('.badge a.btn.hero__btn, .canoe-right a.btn.hero__btn, .specialty a.btn.hero__btn').hover(function(){
            $('.badge .hero-images, .specialty .hero-images, .canoe-right .item-four').toggleClass('selected');
        });
        $('.canoes-types .item-two').hover(function () {
            $(this).closest('.canoes-types .item-two').toggleClass('selected').siblings();
        });

        $(".main-header li").hover(
            function () {
                $(this).addClass('selected');
            }, 
            function () {
                $(this).removeClass('selected');
            }
        );

        $('a.mobile-toggle').on('click', function(){
          $('.social-sharing, .search-blockR, .mobile-menu').toggleClass('selected');
        });
        $('.share-btn').on('click', function(){
          $('.social-sharing, .search-blockR').toggleClass('selected');
        });
        // $('li.search-wrap a.search-btn').on('click', function(){
        //   $('.search-block').toggleClass('selected');
        // });

        $('.mobile-toggle').on('click', function(e) {
          e.preventDefault();
          // $('body').toggleClass('mobile-menu');
          $('.mobile-toggle').toggleClass('active');
          // timber.MiniCart.close();
        });

        // homepage

        $(".my_slideshow").slick({
            arrows: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            useTransform: true,
            speed: 500,
            fade:true,
            adaptiveHeight: true,
            dots: true,
            customPaging: function(my_slideshow, i) { 
                return '<button class="tab">' + $(my_slideshow.$slides[i]).attr('title');
            },
        });

      

          /* media for js*/
        if ($(window).width() <= 767) {


          $("footer.site-footer .item-one h4").click(function() {
            if ($('footer.site-footer ul.site-footer__linklist').is(':visible')) {
              $("footer.site-footer ul.site-footer__linklist").slideUp(300);
              // $(".plusminus").text('+');
              $("footer.site-footer .item-one").removeClass('active');
            }
            if ($(this).next("footer.site-footer ul.site-footer__linklist").is(':visible')) {
              $(this).next("footer.site-footer ul.site-footer__linklist").slideUp(300);
              // $(this).children(".plusminus").text('+');
              $(this).parent("footer.site-footer .item-one").removeClass('active');
            } else {
              $(this).next("footer.site-footer ul.site-footer__linklist").slideDown(300);
              // $(this).children(".plusminus").text('-');
              $(this).parent("footer.site-footer .item-one").addClass('active');
            }
          });  

        } else {
        
   
        }


if ($(window).width() >= 1025) {
  setTimeout(function() {
    $(".canoe-slider").slick("setPosition")
  }, 500)


  // $(".popular-model .items").slick({
  //   dots: true,
  //   infinite: false,
  //   arrows: true,
  //   slidesToShow: 2,
  //   slidesToScroll: 1,
  //   adaptiveHeight: true,
  //   autoplay: false,
  //   autoplaySpeed: 2000,
  //   responsive: [
  //     {
  //       breakpoint: 1024,
  //       settings: {
  //         slidesToShow: 3,
  //         slidesToScroll: 1,
  //         infinite: true,
  //         dots: true
  //       }
  //     },
  //     {
  //       breakpoint: 600,
  //       settings: {
  //         slidesToShow: 2,
  //         slidesToScroll: 2
  //       }
  //     },
  //     {
  //       breakpoint: 480,
  //       settings: {
  //         slidesToShow: 1,
  //         slidesToScroll: 1
  //       }
  //     }
  //     // You can unslick at a given breakpoint now by adding:
  //     // settings: "unslick"
  //     // instead of a settings object
  //   ]
  // }); 
}



$slick_slider_picks = $('.popular-model .items');
top_picks = {
    dots: true,
    infinite: false,
    arrows: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    adaptiveHeight: true,
    autoplay: false,
    autoplaySpeed: 2000,
}
if ( $(window).width() > 1279) {
  $slick_slider_picks.slick(top_picks);
}
$(window).on('resize', function() {
  if ($(window).width() < 1280) {
    if ($slick_slider_picks.hasClass('slick-initialized'))
    $slick_slider_picks.slick('unslick');
    return
  }
  if ( ! $slick_slider_picks.hasClass('slick-initialized'))
  return $slick_slider_picks.slick(top_picks);
});






        //   canoe right for you

        $('.canoe-slider').slick({
          dots: false,
          infinite: true,
          arrows: false,
          slidesToShow: 3,
          slidesToScroll: 1,
          centerMode: true,
          autoplay: false,
          speed: 5000,
          autoplaySpeed: 3000,
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                centerPadding: "150px",
                infinite: true,
                dots: true
              }
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
            // You can unslick at a given breakpoint now by adding:
            // settings: "unslick"
            // instead of a settings object
          ]
        });


        /*
        Smooth scroll functionality for anchor links (animates the scroll
        rather than a sudden jump in the page)
      */
      $('.js-anchor-link').click(function(e){
        e.preventDefault();
        var target = $($(this).attr('href'));
        if(target.length){
          var scrollTo = target.offset().top - 80;
          $('body, html').animate({scrollTop: scrollTo+'px'}, 800);
        }
      });

      $(window).scroll(function(){
        if ($(window).scrollTop() >= 524) {
            $('.menu-scroll').addClass('fixed-header');
        }
        else {
            $('.menu-scroll').removeClass('fixed-header');
        }
      });

        // Product Slider

        $('.product-full .slider').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            // useTransform: true,
            // infinite: true,
            rows: 0,
            centerPadding: '0',
            adaptiveHeight: true,
            swipe: false,
            customPaging: function(slick,index) {
              return '<a>' + index + '</a>';
          },
            nextArrow: '<button type="button" class="slick-next"><span class="fa fa-chevron-right"></span></button>',
            prevArrow: '<button type="button" class="slick-prev"><span class="fa fa-chevron-left"></span></button>',
            cssEase: 'cubic-bezier(1.000, 0.000, 0.000, 1.000)',
            asNavFor: '.product-thumbnail .slider',
            arrows: false,
            dots: false,
        });

        $('.product-thumbnail .slider').slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            // useTransform: true,
            rows: 0,
            centerPadding: '0',
            swipe: true,
          customPaging: function(slick,index) {
              return '<a>' + index + '</a>';
          },
            nextArrow: '<button type="button" class="slick-next"><span class="fa fa-chevron-right"></span></button>',
            prevArrow: '<button type="button" class="slick-prev"><span class="fa fa-chevron-left"></span></button>',
            cssEase: 'cubic-bezier(1.000, 0.000, 0.000, 1.000)',
            asNavFor: '.product-full .slider',
            focusOnSelect: true,
            infinite: true,
            centerMode: false,
            arrows: true,
            dots: false,
            responsive: [
              {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1
                    }
              }
            ]

        });

        // description stuffing


        /*$(".intro-description").html($(".intro_paragraph"));*/
        $("#tab-1").html($(".overview"));
        $("#tab-2").html($(".option-features"));
        $("#tab-3").html($(".specification"));
        $("#tab-4").html($(".pricing"));
        $("#tab-5").html($(".reviews"));

        // request form

        $('.request-info').on('click', function(){
            $('.request-form').addClass('active');
            $('.modal-overlay').addClass('active-overlay');
            $('.template-product').addClass('overflow');
        })

        $('.modal-close').on('click', function(){
            $('.request-form').removeClass('active');
            $('.modal-overlay').removeClass('active-overlay');
            $('.template-product').removeClass('overflow');
        })

        $('.share_story').on('click', function(){
          $('.share_us_form').addClass('active');
          $('.modal-overlay').addClass('active-overlay');
          $('.template-blog').addClass('overflow');
      })

      $('.modal-close').on('click', function(){
          $('.share_us_form').removeClass('active');
          $('.modal-overlay').removeClass('active-overlay');
          $('.template-blog').removeClass('overflow');
      })


        // tabs

        $('.tabs-nav a').on('click', function (event) {
            event.preventDefault();
            
            $('.tab-active').removeClass('tab-active');
            $(this).parent().addClass('tab-active');
            $('.tabs-stage .tabs-content').hide();
            $($(this).attr('href')).show();
        });

        $('.tabs-nav a:first').trigger('click'); // Default

        // product image feat slides

        $('.feat-slides').slick({
            dots: false,
            arrows: true,
            infinite: true,
            speed: 300,
            autoplay: true,
            slidesToShow: 2,
            // useTransform: true,
            // cssEase: 'cubic-bezier(1.000, 0.000, 0.000, 1.000)',
            slidesToScroll: 1,
            responsive: [
              {
                breakpoint: 1024,
                settings: {
                  slidesToShow: 3,
                  slidesToScroll: 3,
                  infinite: true,
                  dots: false
                }
              },
              {
                breakpoint: 600,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 2
                }
              },
              {
                breakpoint: 480,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1
                }
              }
              // You can unslick at a given breakpoint now by adding:
              // settings: "unslick"
              // instead of a settings object
            ]
          });





        // equal heights

        $.fn.equalHeights = function(){
            var max_height = 0;
            $(this).each(function(){
                max_height = Math.max($(this).height(), max_height);
            });
            $(this).each(function(){
                $(this).height(max_height);
            });
        };


        $(document).ready(function(){
          $('.wrap-item p,  .item-six .inne-blog, .wrapper-links, .stories .blog-wrapperR').equalHeights();
        });


        // accordion

        $(document).ready(function() {
          //toggle the component with class accordion_body
            $(".accordion_head").click(function() {
              if ($('.accordion_body').is(':visible')) {
                $(".accordion_body").slideUp(300);
                // $(".plusminus").text('+');
                $(".accord").removeClass('active');
              }
              if ($(this).next(".accordion_body").is(':visible')) {
                $(this).next(".accordion_body").slideUp(300);
                // $(this).children(".plusminus").text('+');
                $(this).parent(".accord").removeClass('active');
              } else {
                $(this).next(".accordion_body").slideDown(300);
                // $(this).children(".plusminus").text('-');
                $(this).parent(".accord").addClass('active');
              }
            });

            
        });


        //  canoe builder
        $(".type-canoe input[type='radio']").click(function() {
          $('.label').text('Select');
          if(this.checked){
           $(this).next().text('Selected');
          }
        });

        // search Autofocus
        var submitIcon = $('.searchbox-icon');
        var inputBox = $('.searchbox-input');
        var searchBox = $('.search-block');
        var isOpen = !1;
        submitIcon.click(function() {
          if (isOpen == !1) {
            searchBox.addClass('selected');
            inputBox.focus();
            isOpen = !0
          } else {
            searchBox.removeClass('selected');
            inputBox.focusout();
            isOpen = !1
          }
        });
        submitIcon.mouseup(function() {
          return !1
        });
        searchBox.mouseup(function() {
          return !1
        });
        // $(document).mouseup(function() {
        //   if (isOpen == !0) {
        //     $('.searchbox-icon').css('display', 'inline-block');
        //     submitIcon.click()
        //   }
        // });



      // product page thumbnail

      $('.thumbnails-wrapper ul.slide-me').slick({
        dots: false,
        arrows: true,
        infinite: false,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 1
      });